import { render, staticRenderFns } from "./FormStates.vue?vue&type=template&id=6dda06e6"
import script from "./FormStates.vue?vue&type=script&lang=js"
export * from "./FormStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports